import React from 'react';

import PropTypes from 'prop-types';

import CardList from '@/components/common/CardList';
import Spinner from '@/components/common/Spinner';
import InspectorCard from '@/components/InspectorsPage/InspectorList/InspectorCard';
const InspectorListComponent = ({ isBusy, cards }) =>
  isBusy ? (
    <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2">
      <Spinner />
    </div>
  ) : (
    <CardList cards={cards} Element={InspectorCard} />
  );

InspectorListComponent.propTypes = {
  isBusy: PropTypes.bool.isRequired,
  cards: PropTypes.array,
};

InspectorListComponent.defaultProps = {
  cards: [],
};

export default InspectorListComponent;
